module.exports = __webpack_public_path__ + "static/media/DIN_NEXTظ_ت_ARABIC_MEDIUM_.22c9874c.otf";